import { render, staticRenderFns } from "./v-apply-new.vue?vue&type=template&id=5a1f55ae&scoped=true&"
import script from "./v-apply-new.vue?vue&type=script&lang=ts&"
export * from "./v-apply-new.vue?vue&type=script&lang=ts&"
import style0 from "./v-apply-new.vue?vue&type=style&index=0&id=5a1f55ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f55ae",
  null
  
)

export default component.exports